import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function ClockIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.156 0.600006H4.37667C2.11162 0.600006 0.600006 2.22174 0.600006 4.54401V9.98934C0.600006 12.314 2.10714 13.9333 4.37667 13.9333H10.1553C12.4251 13.9333 13.9333 12.3138 13.9333 9.98934V4.54401C13.9333 2.21968 12.4252 0.600006 10.156 0.600006ZM4.37667 1.60001H10.156C11.8563 1.60001 12.9333 2.75665 12.9333 4.54401V9.98934C12.9333 11.7768 11.8563 12.9333 10.1553 12.9333H4.37667C2.6761 12.9333 1.60001 11.7772 1.60001 9.98934V4.54401C1.60001 2.75892 2.68023 1.60001 4.37667 1.60001ZM7.76184 4.28783C7.72873 4.04378 7.51954 3.85567 7.26641 3.85567C6.99026 3.85567 6.76641 4.07953 6.76641 4.35567V7.26301L6.77198 7.3375C6.79406 7.4842 6.88063 7.61508 7.01024 7.6924L9.27091 9.04107L9.33151 9.07191C9.55806 9.16851 9.82678 9.08523 9.95647 8.86784L9.98731 8.80724C10.0839 8.58069 10.0006 8.31197 9.78324 8.18228L7.76621 6.97854L7.76641 4.35567L7.76184 4.28783Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
